'use client';

import dynamic from 'next/dynamic';
import React from 'react';

interface DynamicZoneComponent {
  __component: string;
  id: number;
  documentId?: string;
  [key: string]: unknown;
}

interface Props {
  dynamicZone: DynamicZoneComponent[];
  locale: string;
}

const componentMapping: { [key: string]: any } = {
  'dynamic_zone.hero': dynamic(() => import('./hero').then((mod) => mod.Hero)),
  'dynamic_zone.features': dynamic(() =>
    import('./features').then((mod) => mod.Features)
  ),
  'dynamic_zone.testimonials': dynamic(() =>
    import('./testimonials').then((mod) => mod.Testimonials)
  ),
  'dynamic_zone.how-it-works': dynamic(() =>
    import('./how-it-works').then((mod) => mod.HowItWorks)
  ),
  'dynamic_zone.brands': dynamic(() =>
    import('./brands').then((mod) => mod.Brands)
  ),
  'dynamic_zone.pricing': dynamic(() =>
    import('./pricing').then((mod) => mod.Pricing)
  ),
  'dynamic_zone.launches': dynamic(() =>
    import('./launches').then((mod) => mod.Launches)
  ),
  'dynamic_zone.cta': dynamic(() => import('./cta').then((mod) => mod.CTA)),
  'dynamic_zone.form-next-to-section': dynamic(() =>
    import('./form-next-to-section').then((mod) => mod.FormNextToSection)
  ),
  'dynamic_zone.faq': dynamic(() => import('./faq').then((mod) => mod.FAQ)),
  'dynamic_zone.related-products': dynamic(() =>
    import('./related-products').then((mod) => mod.RelatedProducts)
  ),
  'dynamic_zone.related-articles': dynamic(() =>
    import('./related-articles').then((mod) => mod.RelatedArticles)
  ),
  'dynamic_zone.slideshow': dynamic(() =>
    import('./slideshow').then((mod) => mod.Slideshow)
  ),
  'dynamic_zone.single-article': dynamic(() =>
    import('./single-article').then((mod) => mod.SingleArticle)
  ),
  'dynamic_zone.articles-by-category': dynamic(() =>
    import('./articles-by-category').then((mod) => mod.ArticlesByCategory)
  ),
};

const DynamicZoneManager: React.FC<Props> = ({ dynamicZone, locale }) => {
  return (
    <div>
      {dynamicZone.map((componentData, index) => {
        const Component = componentMapping[componentData.__component];
        if (!Component) {
          console.warn(`No component found for: ${componentData.__component}`);
          return null;
        }
        return (
          <Component
            key={`${componentData.__component}-${componentData.id}-${index}`}
            {...componentData}
            locale={locale}
          />
        );
      })}
    </div>
  );
};

export default DynamicZoneManager;
